import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import store from "./store.jsx";
import { Provider } from "react-redux";

import * as serviceWorker from './serviceWorker';

import IdentityService from './services/identity.service.jsx';
import RequestInterceptor from './services/request.interceptor.jsx';
import mixpanel from 'mixpanel-browser';

import 'semantic-ui-css/semantic.min.css';
import './index.css';

IdentityService.initialise().then(() => {
  RequestInterceptor("5ed154409db1725f766275df");
  mixpanel.init("3db48ceacceaf818522276bdca4d22c5");

  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root')
  );  
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

